import delve from 'dlv';

import { isInBetween } from 'Util/DateUtils';
import { getConfig } from 'Util/Config';

const mfBannerStartDate = delve(getConfig().mockFreeBanner, 'startDate');
const mfBannerEndDate = delve(getConfig().mockFreeBanner, 'endDate');

export const isBannerCTAEnabled = mfBannerStartDate
  ? isInBetween(mfBannerStartDate, mfBannerEndDate)
  : false;

export const getPopup = () => {
  const popup = delve(getConfig().mockFreeBanner, 'overviewPopup', []);
  const { image, link } = popup;
  return { image, link };
};

/**
 *
 * @param {string} subjectCode NIETS subject code e.g. PAT1 = 71
 * @param {string} tabKey tab1, tab2 or tab3
 */
export const getBanner = (subjectCode, tabKey) => {
  const allSubj = delve(getConfig().mockFreeBanner, 'subjects', []);
  const subject = allSubj.find(subj => subj.subjectCode === subjectCode);

  if (subject && subject[tabKey]) {
    const { image, link } = subject[tabKey];
    return { image, link };
  }
  return {};
};

export const getSolutionDetailsAds = () =>
  delve(getConfig().mockFreeBanner, 'solutionDetailsAds', {});

// TODO: testable function
export const getRequiredExams = departmentData => {
  const { admissionRounds } = departmentData;
  if (Array.isArray(admissionRounds)) {
    const round4 = admissionRounds.find(
      round =>
        Array.isArray(round) && round.length > 0 && round[0].roundNo && round[0].roundNo === 4,
    );

    if (Array.isArray(round4) && round4.length > 0) {
      return round4[0].requiredExams;
    }
  }
  return [];
};

export const getLatestExamRounds = (examRounds = []) => {
  return delve(examRounds, ['0'], {});
};
